import React, { useState } from "react";

// used for making the prop types of this component
import PropTypes from "prop-types";

// core components
import Button from "./Button.jsx";

import defaultImage from "../assets/img/image_placeholder.jpg";
import defaultAvatar from "../assets/img/placeholder.jpg";
import pdfimage from "../assets/img/pdf-icon.png";
import MDBox from "./MDBox/index.js";

export default function ImageUpload({ ...props }) {

    var {
        avatar,
        id,
        name,
        ocultarBotonesProps,
        marginImage,
        connombrefichero
    } = props;

    const [file, setfile] = useState(null);
    const [imagePreviewUrl, setimagePreviewUrl] = useState(props.avatar ? defaultAvatar : defaultImage);
    const [imageUrl, setimageUrl] = useState(props.imageUrl);
   

    var fileInput = React.createRef();

    const handleImageChange = e => {
        e.preventDefault();
        let reader = new FileReader();
        let fileread = e.target.files[0];
        reader.onloadend = () => {
            setfile(fileread);
            setimageUrl(reader.result);       
        };

        reader.readAsDataURL(fileread);
    };

    const handleSubmit = e => {
        e.preventDefault();
        // file is the file/image uploaded
        // in this function you can save the image (file) on form submit
        // you have to call it yourself
    };

    const handleClick = e => {
        e.preventDefault();
        fileInput.current.click();
    };

    const handleRemove = () => {

        setfile(null);
        setimageUrl(props.avatar ? defaultAvatar : defaultImage);
      
        fileInput.current.value = null;
    };
    
    let imageshow = imageUrl != null && imageUrl != '' ? imageUrl : imagePreviewUrl;

    return (
        <MDBox >
            {connombrefichero != null && connombrefichero && file != null ? <input id="nombrefile" name="nombrefile" type='hidden' value={file.name} /> : "" }
            <input type="file" onChange={handleImageChange} ref={fileInput} style ={{ opacity: 0 }} />
            <input id={id} name={name} type='hidden' value={imageUrl} />
            <MDBox
                color="text"
                bgColor="#f7f7f7"
                shadow="lg"
                opacity={1}
                fontSize={14}
                m={marginImage != null ? marginImage : 1}
                minHeight={50}
                display="flex"
                justifyContent="center"
                maxWidth={ 350}
                
            >
                {file != null && file.type == "application/pdf" ?
                    <img style={{ height: "125px", width: "100px" }} src={pdfimage} alt="..." /> : <img src={imageshow} alt="..." style={{ maxWidth: '100%' }} />}
            </MDBox>
            {ocultarBotonesProps ? "" :
                <MDBox display="flex"
                    justifyContent="center"
                    alignItems="center">
                    {file === null && (imageUrl == 'undefined' || imageUrl == null || imageUrl == "") ?
                        (
                            <Button color="primary" size="small" onClick={(e) => handleClick(e)}>
                                {avatar ? "A�adir" : "Seleccionar"}
                            </Button>
                        ) : (
                            <span>
                                <Button color="primary" size="small" onClick={(e) => handleClick(e)}>
                                    Cambiar
                                </Button>
                                {avatar ? <br /> : null}
                                <Button color="error" size="small"
                                    onClick={() => handleRemove()}
                                >
                                    <i className="fas fa-times" /> Eliminar
                                </Button>
                            </span>
                        )}
                </MDBox>
            }
        </MDBox>
    );
}

ImageUpload.propTypes = {
    avatar: PropTypes.bool,
    addButtonProps: PropTypes.object,
    changeButtonProps: PropTypes.object,
    removeButtonProps: PropTypes.object,
    ocultarBotonesProps: PropTypes.object,
    marginImage: PropTypes.object,
    connombrefichero: PropTypes.bool
};

/*
class ImageUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      file: null,
      imagePreviewUrl: this.props.avatar ? defaultAvatar : defaultImage,
        imageUrl: this.props.imageUrl,
        evento: false
    };
  }
  fileInput = React.createRef();
  handleImageChange = e => {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];
    reader.onloadend = () => {
      this.setState({
        file: file,
        //  imagePreviewUrl: reader.result,
          imageUrl: reader.result,
          evento: true
      });
    };
    reader.readAsDataURL(file);
  };
  handleSubmit = e => {
    e.preventDefault();
    // file is the file/image uploaded
    // in this function you can save the image (file) on form submit
    // you have to call it yourself
  };
    handleClick = e => {
        e.preventDefault();
    this.fileInput.current.click();
  };
  handleRemove = () => {
      this.setState({
          file: null,
          imagePreviewUrl: this.props.avatar ? defaultAvatar : defaultImage,
          imageUrl: "",
          evento: true
      });
    this.fileInput.current.value = null;
  };
  render() {
    var {
      avatar,
      addButtonProps,
      changeButtonProps,
      removeButtonProps,   
      id,
      name
    } = this.props;

      //Si el que ha provocado el cambio es el evento entonces el valor del input es el que viene del evento, pero sino, el valor sera el de por defecto    
      let imageUrlFinal = evento ? imageUrl : this.props.imageUrl;      

      //Si salto por algo que no es evento, y la propiedad recibida esta vacia pero hay una imagen, esto se debe a que existio un error, por tanto, mantengo la imagen que estaba
      if (!evento && this.props.imageUrl == null && imageUrl != null)
          imageUrlFinal = imageUrl;

      evento = false;

      let imageshow = imageUrlFinal != null && imageUrlFinal != '' ? imageUrlFinal : imagePreviewUrl;

      //Si la imagen es vacia, no puede existir un fichero asociado
      if (imageUrlFinal == null || imageUrlFinal == "")
          file = null;
      //let imageshow = imageUrl != null && imageUrl != '' ? imageUrl : imagePreviewUrl;

    return (
      <div className="fileinput text-center">
            <input type="file" onChange={this.handleImageChange} ref={this.fileInput} />
            <input id={id} name={name} type='hidden' value={imageUrlFinal} />            

            <div className={"thumbnail" + (avatar ? " img-circle" : "")}>
                {file != null && file.type == "application/pdf" ?
                    <img style={{ height: "125px", width: "100px" }} src={pdfimage} alt="..." /> : <img src={imageshow} alt="..." />}
            </div>
            <div>
                {file === null && (imageUrlFinal == 'undefined' || imageUrlFinal == null || imageUrlFinal == "") ?
                    (
                        <Button {...addButtonProps} onClick={(e) => this.handleClick(e)}>
                          {avatar ? "A�adir" : "Seleccionar"}
                        </Button>
                   ) : (
                        <span>
                          <Button {...changeButtonProps} onClick={(e) => this.handleClick(e)}>
                            Cambiar
                          </Button>
                          {avatar ? <br /> : null}
                          <Button
                            {...removeButtonProps}
                            onClick={() => this.handleRemove()}
                          >
                            <i className="fas fa-times" /> Eliminar
                          </Button>
                        </span>
                      )}
            </div>
      </div>
    );
  }
}*/




